import { useApi } from "../../hooks/useApi";
import { templateService } from "../../services/templates";
import { TemplateUploadResponse, TemplateFileNameResponse } from "../../types/template.types";
import { useSession } from "../../context/SessionContext";

export function useTemplates() {
  const { metadata } = useSession();

  const uploadApi = useApi<TemplateUploadResponse>();
  const fileNameApi = useApi<TemplateFileNameResponse>();

  const uploadTemplate = async (folder: string, file: File) => {
    if (!metadata.email) return null;

    return uploadApi.request(
      () => templateService.upload(uploadApi.apiFetchForm, folder, metadata.email!, file),
    );
  };

  const getTemplateFileName = async (folder: string) => {
    if (!metadata.email) return null;

    // Consulta silenciosa disparada no mount — não deve tostar erro toda
    // vez que a tela abre, ainda mais se o médico nunca subiu um arquivo.
    return fileNameApi.request(
      () => templateService.getFileName(fileNameApi.apiFetch, folder, metadata.email!),
      { showErrorToast: false },
    );
  };

  return {
    uploadTemplate,
    getTemplateFileName,
    uploading: uploadApi.loading,
    fetchingFileName: fileNameApi.loading,
  };
}
